import { useTranslation } from 'react-i18next';
import logoHorizontal from '../assets/images/logo/logo.png';

export default function Logo({ className = '' }) {
  const { t } = useTranslation();
  
  return (
    <img 
      src={logoHorizontal} 
      alt={t('bus_company')}
      className={`h-16 md:h-20 object-contain ${className}`} // Taille augmentée
    />
  );
}